var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLampada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_5139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 10.138L29.5 11.3047M5 20.8047H6.66667H5ZM20 5.80469V7.47135V5.80469ZM33.3333 20.8047H35H33.3333ZM9.33333 10.138L10.5 11.3047L9.33333 10.138Z",
    stroke: "#FF9700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 27.4717C13.6009 26.4223 12.5673 24.9592 12.0458 23.2897C11.5243 21.6203 11.5413 19.829 12.0944 18.1698C12.6475 16.5105 13.7086 15.0673 15.1275 14.0447C16.5464 13.022 18.2511 12.4717 20.0001 12.4717C21.7491 12.4717 23.4538 13.022 24.8727 14.0447C26.2915 15.0673 27.3527 16.5105 27.9058 18.1698C28.4589 19.829 28.4759 21.6203 27.9544 23.2897C27.4329 24.9592 26.3993 26.4223 25.0001 27.4717C24.3494 28.1158 23.8594 28.9041 23.5699 29.7727C23.2803 30.6413 23.1993 31.5659 23.3334 32.4717C23.3334 33.3557 22.9822 34.2036 22.3571 34.8287C21.732 35.4538 20.8841 35.805 20.0001 35.805C19.116 35.805 18.2682 35.4538 17.6431 34.8287C17.0179 34.2036 16.6667 33.3557 16.6667 32.4717C16.8008 31.5659 16.7198 30.6413 16.4303 29.7727C16.1408 28.9041 15.6508 28.1158 15.0001 27.4717",
    stroke: "#FF9700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.167 29.1377H23.8337",
    stroke: "#FF9700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_5139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.804688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampada);
export default __webpack_public_path__ + "static/media/lampada.fc8516336fc161a5ee7516e7eb382728.svg";
export { ForwardRef as ReactComponent };